import { Empty as AntdEmpty } from 'antd';
import NoDataIcon from '@rootCommon/assets/img/no-data-image.svg';

import './Empty.scss';

const Empty = (): JSX.Element => (
  <div className="empty-wrapper">
    <AntdEmpty
      image={NoDataIcon}
      description={false}
    />
  </div>
);

export default Empty;
